var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFitclubproIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 86,
    viewBox: "0 0 85 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5567_14669)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.2401 24.0008C46.2401 20.0243 49.4234 16.8008 53.3501 16.8008C57.2769 16.8008 60.4601 20.0243 60.4601 24.0008C60.4601 27.9772 57.2769 31.2008 53.3501 31.2008C51.9589 31.2008 50.6609 30.7961 49.5648 30.0967L45.3146 34.4008L50.1594 39.3069C50.6691 39.8231 51.4512 39.9193 52.0625 39.5638L52.2246 39.4556L56.3521 36.3208C57.0502 35.7906 58.0406 35.9339 58.5641 36.6408C59.0474 37.2933 58.964 38.1981 58.3993 38.7504L58.2481 38.8808L54.1206 42.0156C52.3156 43.3865 49.8211 43.2722 48.1479 41.7815L47.925 41.5697L43.0801 36.6635L26.8173 53.1322C26.2003 53.757 25.1999 53.757 24.5829 53.1322C24.0133 52.5554 23.9695 51.6478 24.4515 51.0201L24.5829 50.8694L41.9617 33.2706C41.9621 33.2702 41.9625 33.2698 41.9629 33.2694C41.9633 33.269 41.9637 33.2686 41.9641 33.2682L47.3304 27.834C46.6397 26.724 46.2401 25.4096 46.2401 24.0008ZM57.3001 24.0008C57.3001 21.7916 55.5316 20.0008 53.3501 20.0008C51.1686 20.0008 49.4001 21.7916 49.4001 24.0008C49.4001 26.2099 51.1686 28.0008 53.3501 28.0008C55.5316 28.0008 57.3001 26.2099 57.3001 24.0008ZM33.0612 25.288C34.5755 24.9046 36.1719 25.3019 37.3357 26.3354L37.5625 26.5506L39.4573 28.4694C40.0744 29.0942 40.0744 30.1073 39.4573 30.7322C38.8878 31.3089 37.9916 31.3533 37.3717 30.8653L37.2229 30.7322L35.328 28.8133C34.9846 28.4656 34.5056 28.2998 34.0305 28.3551L33.8276 28.3924L29.2433 29.553C28.3968 29.7673 27.5389 29.2461 27.3273 28.3888C27.1308 27.5928 27.5605 26.7869 28.3007 26.5043L28.4769 26.4486L33.0612 25.288ZM44.0485 42.7363C43.4287 42.2483 42.5325 42.2926 41.9629 42.8694C41.3459 43.4942 41.3459 44.5073 41.9629 45.1322L43.0875 46.271L43.2189 46.4217C43.7008 47.0494 43.657 47.9569 43.0875 48.5337C42.914 48.7093 42.7026 48.8417 42.4699 48.9202L37.8405 50.4829L37.669 50.5521C36.9524 50.8914 36.585 51.7283 36.8412 52.5067C37.1171 53.3451 38.0119 53.7981 38.8398 53.5187L43.4692 51.956L43.8127 51.8249C44.3755 51.5844 44.8883 51.2355 45.3219 50.7964C47.173 48.9219 47.173 45.8827 45.3219 44.0082L44.1973 42.8694L44.0485 42.7363Z",
    fill: "#1F1D39"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5567_14669",
    x: -1.45996,
    y: 0.800781,
    width: 85.9199,
    height: 86.4004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.228155 0 0 0 0 0 0 0 0 0.48 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5567_14669"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5567_14669",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFitclubproIcon);
export default __webpack_public_path__ + "static/media/fitclubpro-icon.7798d579328a0f2a11da6378bfcec41c.svg";
export { ForwardRef as ReactComponent };